import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getPoint, resetPoint } from '../../store/actions/point';
import { getStory, resetStory } from '../../store/actions/story';
import { navigateSpace } from '../../store/actions/app';
import { PointSpace } from '../../containers/xr/space';
import { RootState } from '../../types/data';
import GatewayService from '../../services/gateway-service';
import { STORY_LOADED } from '../../common/constants/gateway-events';
import { Helmet } from 'react-helmet';
import { useActions } from '../../hooks';
import axios from 'axios';

// type TStoryRouteProps = RouteComponentProps<>;
type TStoryRouteReduxState = {
  story: RootState['story']['current'];
};

const StoryRoute = () => {
  const { university, storyId } = useParams<{ university: string; storyId: string }>();
  const { story } = useSelector<RootState, TStoryRouteReduxState>(state => ({ story: state.story.current }));
  const boundActions = useActions({
    getStory,
    resetStory,
    getPoint,
    resetPoint,
    navigateSpace,
  });

  // data fetching functional
  useEffect(() => {
    if (!storyId) return;

    // create the source
    const reqSource = axios.CancelToken.source();

    (async () => {
      const {
        __HANDLED_ERROR__,
        payload: {
          data: { response: res },
        },
        // @ts-ignore
      } = await (boundActions.getStory(university, storyId, reqSource.token) as Promise<any>);

      if (__HANDLED_ERROR__) return;

      // boundActions.resetPoint();

      // @ts-ignore
      const {
        __HANDLED_ERROR__: P__HANDLED_ERROR__,
        payload: {
          data: { response },
        },
        // @ts-ignore
      } = await (boundActions.getPoint(university, res.point_id, reqSource.token) as Promise<any>);
      if (!P__HANDLED_ERROR__) {
        boundActions.navigateSpace(response);
      }
    })();

    return () => {
      reqSource.cancel('Point changed.');
      boundActions.resetStory();
    };
  }, [boundActions, storyId, university]);

  useEffect(() => {
    if (story.loaded && !!story.data) {
      GatewayService.emit(STORY_LOADED, story.data);
    }
  }, [story.loaded, story.data]);

  const pageTitle = story.data?.title;

  return (
    <>
      <Helmet>{pageTitle ? <title>{`${pageTitle} | 360 Stories`} </title> : null}</Helmet>
      <PointSpace />
    </>
  );
};

export default StoryRoute;
